import './axiosJsonInterceptor';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
//added for css imports
import 'react-calendar/dist/Calendar.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppWrapper from './template/AppWrapper';
import { UserProvider } from './common';

const IntelApp = () => (
  <UserProvider>
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  </UserProvider>
);

const root = createRoot(document.getElementById('root'));
root.render(<IntelApp />);

reportWebVitals();
